import { ILocale } from '../modules/localization';

export const LOCALES: ILocale[] = [
  { id: 'en', name: 'LOCALE.LANGUAGES.ENGLISH' },
  { id: 'en-GB', name: 'LOCALE.LANGUAGES.ENGLISH-KE' },
  { id: 'sw-KE', name: 'LOCALE.LANGUAGES.KISWAHILI-KE' },
  { id: 'sw-TZ', name: 'LOCALE.LANGUAGES.KISWAHILI-TZ' },
  { id: 'sw', name: 'LOCALE.LANGUAGES.SWAHILI' },
  { id: 'en-GB', name: 'LOCALE.LANGUAGES.ENGLISH-UG' },
  { id: 'rw-RW', name: 'LOCALE.LANGUAGES.RWANDESE' },
  { id: 'fr-CD', name: 'LOCALE.LANGUAGES.FRENCH-DRC' },
  { id: 'fr-RW', name: 'LOCALE.LANGUAGES.FRENCH-RW' },
  { id: 'ha-SD', name: 'LOCALE.LANGUAGES.SUDANESE' },
  { id: 'en-GB', name: 'LOCALE.LANGUAGES.ENGLISH' },
];
